import React, { memo, useMemo, useContext } from "react";
import ProgressBar from "./progressBar";
import {
  resultsFilesDownloadClick,
  generateImageString,
  getProcessName,
  IsraeliDateOptions,
} from "../services/helper";
import { ConfigContext } from "./../context/ConfigContext";

const ProcessCard = memo((props) => {
  const config = useContext(ConfigContext);

  const rb12s = useMemo(() => ["D2_D3_ALL", "D2_ALL"], []);
  const isRB = useMemo(
    () => rb12s?.includes(props?.["selectedRuns"]),
    [props?.["selectedRuns"], rb12s]
  );


  // Determine severity based on pre-computed severity arrays
  const highestSeverity = useMemo(() => {
    // If canceled or improper status, override to Stop (red)
    if (props?.["isSomeCanceled"] || props?.["notProperStatus"]) {
      return "Stop";
    }

    // Simple logic based on pre-computed severity arrays
    if (props?.["stopSeverity"]?.length > 0) {
      return "Stop"; // Red
    } else if (props?.["criticalSeverity"]?.length > 0) {
      return "Critical"; // Yellow
    } else {
      return "Report"; // Green (default/pass)
    }
  }, [
    props?.["isSomeCanceled"],
    props?.["notProperStatus"],
    props?.["stopSeverity"],
    props?.["criticalSeverity"],
  ]);

  const {
    comparisonTests = [],
    advancedTesting = [],
    conversionTests = [],
  } = props?.["selectedRuns"] === "on" &&
  props?.["dataList"]?.reduce(
    (acc, checkList) => {
      if (checkList?.["checkType"] === "D3") {
        if (
          !!props?.["D3_advanced"]?.find(
            (list) => list?.["checkNo"] === checkList?.["checkNumber"]
          )?.["checkNo"]
        ) {
          acc["advancedTesting"] = [
            ...acc["advancedTesting"],
            checkList?.["checkNumber"],
          ];
        } else if (
          !!props?.["D3_cmp"]?.find(
            (list) => list?.["checkNo"] === checkList?.["checkNumber"]
          )?.["checkNo"]
        ) {
          acc["comparisonTests"] = [
            ...acc["comparisonTests"],
            checkList?.["checkNumber"],
          ];
        }
      } else {
        acc["conversionTests"] = [
          ...acc["conversionTests"],
          checkList?.["checkNumber"],
        ];
      }
      return acc;
    },
    { comparisonTests: [], advancedTesting: [], conversionTests: [] }
  );

  return (
    <div className="" style={{ width: "100%", textAlign: "right" }}>
      <div className="card-body">
        {/* Block number - מספר גוש ,date - תמר */}
        {!!props?.["gushValue"]?.length && !!props?.["processValue"]?.length ? (
          <h5>
            {getProcessName(props?.["processValue"], props?.["gushValue"])}
            {/* {" 200/5000, " + "תמר"} */}
            {/* {3507 + " מספר גוש "} */}
          </h5>
        ) : null}
        {/* If RB1 or RB2 - Beginning of conversion tests,  If RB3 - Start tests */}
        {props?.["localStartTime"] !== undefined ? (
          <h6>
            {/* {"17:31 , 17/09/2024 "} */}
            {new Date(props?.["localStartTime"]).toLocaleString(
              "he-IL",
              IsraeliDateOptions
            )}
            {isRB
              ? ` תחילת בדיקות ${
                  props?.["checkType"] === "D3" ? " מתקדמות/השוואה " : " המרה "
                } `
              : ` תחילת בדיקות `}
          </h6>
        ) : null}
        {props?.["selectedRuns"] === "on" ? (
          <div>
            {!!conversionTests?.length ? (
              <h6>{conversionTests?.join(" ,") + ` - בדיקות המרה `}</h6>
            ) : null}
            {!!advancedTesting?.length ? (
              <h6>{advancedTesting?.join(" ,") + ` - בדיקות מתקדמות `}</h6>
            ) : null}
            {!!comparisonTests?.length ? (
              <h6>{comparisonTests?.join(" ,") + ` - בדיקות השוואה `}</h6>
            ) : null}
          </div>
        ) : null}
        <ProgressBar
          key={`progress-${props?.["batchID"]}-${highestSeverity}-${props?.["isBlinking"]}`}
          progress={
            props?.["isSomeCanceled"] || props?.["notProperStatus"]
              ? 100
              : props?.["progressStatus"]
          }
          total={props?.["dataList"]?.length}
          completed={
            props?.["completedList"]?.length === props?.["dataList"]?.length &&
            props?.["progressStatus"] !== 100
              ? props?.["completedList"]?.length - 1
              : props?.["completedList"]?.length
          }
          severity={highestSeverity}
          isSomeCanceled={
            props?.["isSomeCanceled"] || props?.["notProperStatus"]
          }
          isBlinking={props?.["isBlinking"]}
        />
        {props?.progressStatus === 100 &&
        props?.["localEndTime"] !== undefined ? (
          <p className="m-0 mt-1">
            {new Date(props?.["localEndTime"]).toLocaleString(
              "he-IL",
              IsraeliDateOptions
            )}
            {/* {getEndTime(props?.["localStartTime"], props?.["dataList"])} */}
            {isRB
              ? ` סיום בדיקות  ${
                  props?.["checkType"] === "D3" ? " מתקדמות/השוואה " : " המרה "
                } `
              : ` סיום בדיקות `}
            {/* {isRB ? " סיום בדיקות המרה " : " סיום בדיקות "} */}
          </p>
        ) : null}
        {props?.["isSomeCanceled"] ? "התהליך בוטל באמצע" : ""}
        {/* A reporting errors and b critical/stopping errors were found. To view the report click here */}
        {/* נמצאו א שגיאות דיווח ו- ב שגיאות קריטיות/עוצרות. לצפייה בדו"ח לחץ כאן */}

        {props?.["progressStatus"] === 100 && !props?.["isSomeCanceled"] ? (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            {props?.["reportSeverity"]?.length > 0 ||
            props?.["criticalSeverity"]?.length > 0 ||
            props?.["stopSeverity"]?.length > 0 ? (
              <p>
                {".לחץ"}
                <span
                  role="button"
                  className="text-primary"
                  onClick={() => {
                    const fileName = rb12s?.includes(props?.["selectedRuns"])
                      ? `${
                          props?.["checkType"] === "D2"
                            ? "Migration Checks"
                            : "Advanced Checks"
                        }`
                      : `Various Checks`;
                    resultsFilesDownloadClick(
                      config.generalEndPoint,
                      props?.["batchID"],
                      `${fileName}_${
                        props?.["fileName"]
                      }_${generateImageString()}.dwg`,
                      "DWG"
                    );
                  }}
                >
                  {" כאן"}
                </span>
                {" DWG "}
                {"לצפייה בקובץ ."}
              </p>
            ) : (
              ""
            )}
            {(props?.["reportSeverity"]?.length > 0 ||
              props?.["criticalSeverity"]?.length > 0 ||
              props?.["stopSeverity"]?.length > 0) && (
              <p className="m-0">
                {`נמצאו ${props?.["reportSeverity"]?.length || 0} שגיאות דיווח, ${
                  props?.["criticalSeverity"]?.length || 0
                } שגיאות קריטיות ו-${props?.["stopSeverity"]?.length || 0} שגיאות עוצרות.`}
                {` לצפייה בדו"ח לחץ `}
                <span
                  role="button"
                  className="text-primary"
                  onClick={() => {
                    const fileName = rb12s?.includes(props?.["selectedRuns"])
                      ? `${
                          props?.["checkType"] === "D2"
                            ? "Migration Checks"
                            : "Advanced Checks"
                        }`
                      : `Various Checks`;
                    resultsFilesDownloadClick(
                      config.generalEndPoint,
                      props?.["batchID"],
                      `${fileName}_${
                        props?.["fileName"]
                      }_${generateImageString()}.xlsx`,
                      "excel"
                    );
                  }}
                >
                  {"כאן"}
                </span>
              </p>
            )}
          </div>
        ) : null}
        <div>...</div>
      </div>
    </div>
  );
});

export default ProcessCard;
